import { Directive, ElementRef, Input, HostListener, Renderer2 } from "@angular/core";
import { ParticipationDataService } from '../_services/participation-data.service';

@Directive({
  selector: "[appTooltip]"
})
export class TooltipDirective {
  @Input() dataContext: any;
  @Input() IsButtonPanel: boolean = false;
  @Input() IsAnswerToolTip: boolean = false;
  @Input() IsHiddenQToolTip: boolean = false;
  @Input() qid: number = 0;

  imageFolder: string;
  isShownHint: boolean = false;
  isTabKey: boolean = false;

  constructor(
    private ele: ElementRef, 
    private service: ParticipationDataService,
    private renderer: Renderer2
  ) { }

  ngOnInit(): void {
    try {
      // Remove and Hide Tooltips on Document Click
      document.addEventListener("click", (event) => {
        try {
          const target = event.target as HTMLElement;
          const classNames = target.className || '';
          if (classNames && (classNames.indexOf("tooltip_container") > -1 || classNames.indexOf("tooltip-text-wrapper") > -1)) {
            return;
          }
          
          const els = document.querySelectorAll(".tooltip_container");
          const datatooltip = document.getElementsByClassName('datatooltip');
          
          for (const el of Array.from(els)) {
            if (el && el.classList) {
              el.classList.remove("active");
            }
          }
          
          for (const dt of Array.from(datatooltip)) {
            if (dt && dt.parentNode) {
              dt.parentNode.removeChild(dt);
            }
          }
          
          this.isShownHint = false;
          this.isTabKey = false;
        } catch (error) {
          console.warn('Error in tooltip click handler:', error);
        }
      });

      const previewTablet = document.querySelector('.preview--tablet');
      const previewMobile = document.querySelector('.preview--mobile');

      if (previewTablet || previewMobile) {
        const appParticipation = document.querySelector(".app-participation");
        if (appParticipation) {
          appParticipation.addEventListener('scroll', () => {
            try {
              const tooltipContainer = document.querySelector(".tooltip_container");
              if (tooltipContainer && getComputedStyle(tooltipContainer).display !== 'none') {
                document.body.click();
              }
            } catch (error) {
              console.warn('Error in tooltip scroll handler:', error);
            }
          });
        }
      } else {
        const bodyScroll = document.getElementById("bodyScroll");
        if (bodyScroll) {
          bodyScroll.addEventListener('scroll', () => {
            try {
              const tooltipContainer = document.querySelector(".tooltip_container");
              if (tooltipContainer && getComputedStyle(tooltipContainer).display !== 'none') {
                document.body.click();
              }
            } catch (error) {
              console.warn('Error in tooltip scroll handler:', error);
            }
          });
        }
      }

      this.imageFolder = this.service.getImageFolder();
    } catch (error) {
      console.warn('Error in tooltip ngOnInit:', error);
    }
  }

  // Hide Tooltips when Mouse is Move out on Web
  @HostListener('mouseout')
  @HostListener('blur')
  hideTooltip() {
    try {
      if (this.IsAnswerToolTip) {
        // Remove All Answer Tooltip
        const els = document.querySelectorAll(".answer,.hiddenQ-tooltip");
        for (const el of Array.from(els)) {
          if (el && el.classList) {
            el.classList.remove("active");
          }
        }
      }
      else {
        if (this.isTabKey) {
          const tooltip = document.getElementById("tooltip-" + this.qid);
          if (tooltip) {
            tooltip.remove();
            this.isTabKey = false;
          }
        }
      }
    } catch (error) {
      console.warn('Error in hideTooltip:', error);
    }
  }

  // Listen to Mouseover, touchstart, click event on Tooltip icon
  @HostListener('mouseover', ['$event'])
  @HostListener('touchstart', ['$event'])
  @HostListener('click', ['$event'])
  @HostListener('keydown', ['$event'])
  @HostListener('focus', ['$event'])
  showTooltip(event) {
    try {
      // If key is tab, mark it
      if (event.type == "keydown" && event.keyCode == 9) {
        this.isTabKey = true;
      }

      // Answer Tooltip
      if (this.IsAnswerToolTip) {
        // Do something with 'event'
        event.stopPropagation();
        
        if (this.ele.nativeElement.hasAttribute("data-tooltipcount")) {
          const tooltipCountVal = this.ele.nativeElement.getAttribute("data-tooltipcount");
          const existingTT = document.querySelector(`[data-tooltip='${tooltipCountVal}']`);
          if (existingTT) {
            existingTT.remove();
          }
        }

        const tooltipCountElements = document.querySelectorAll("[data-tooltipcount]");
        const tooltipCount = tooltipCountElements.length;
        this.ele.nativeElement.setAttribute("data-tooltipcount", (tooltipCount + 1).toString());

        const tooltip = document.createElement("div");
        
        const rect = this.ele.nativeElement.getBoundingClientRect();
        const top = rect.top + window.scrollY;
        const left = rect.left + window.scrollX;
        
        // If Hidden Question IN Preview tooltip
        tooltip.setAttribute("data-tooltip", (tooltipCount + 1).toString());
        document.body.appendChild(tooltip);
      
      if (this.IsHiddenQToolTip) {
        tooltip.classList.add("tooltip_container");
        tooltip.classList.add("hiddenQ-tooltip");
        tooltip.classList.add("active");
        tooltip.innerHTML =
          `<div class="hdn-icn-div" ><img width="30px" height="30px" src="../survey/assets/imagesNew/PM/save_img.png" border="0" /><span>This question will be hidden from participants.</span></div>`;
        this.ele.nativeElement.setAttribute("aria-label", "This question will be hidden from participants.");
        
        // Calculate Width & Height of icon position + tooltip size
        const totalTooltipWidth = left + tooltip.offsetWidth;
        const totalTooltipHeight = top + tooltip.offsetHeight + 25;

        if (this.service.commonSetting.isMobileDevice && !this.service.isRTL) {
          // No need to adjust totalTooltipWidth for mobile as we're not using jQuery's offset
        }

        // If its going outside body show it at right hand
        if (totalTooltipWidth > document.body.offsetWidth) {
          tooltip.style.left = "auto";
          tooltip.style.right =
            (document.body.offsetWidth - rect.left - 16) + "px"; // 2px for arrow 14 px for icon size
          tooltip.classList.add("hiddenQ-right-arrow");
        }
        // else display at left hand
        else {
          tooltip.style.left = (left - 2) + "px";
        }

        // If its going outside body show it at top side
        if (totalTooltipHeight > document.body.offsetHeight + window.scrollY) {
          tooltip.style.top = (top - tooltip.offsetHeight - 10) + "px";
          tooltip.classList.add("hiddenQ-down-arrow");
        }
        // else display at bottom hand
        else {
          tooltip.style.top = (top + 25) + "px";
        }

      }
      // If Answer Quota Tooltip
      else {
        tooltip.classList.add("tooltip_container");
        tooltip.classList.add("answer");
        tooltip.classList.add("active");
        tooltip.innerHTML = this.dataContext;
        this.ele.nativeElement.setAttribute("aria-label", this.dataContext);
        tooltip.style.left = (left - 30) + "px";
        tooltip.style.top = (top + 25) + "px";
      }
    }
    // Hint Tooltip
    else {
      if (event.type == "mouseover") {
        return;
      }
      
      const visibleTooltip = document.querySelector(".tooltip_container");
      if (visibleTooltip && getComputedStyle(visibleTooltip).display !== 'none') {
        document.body.click();
      }
      
      // Do something with 'event'
      event.stopPropagation();
      
      const tooltipCountElements = document.querySelectorAll("[data-tooltipcount]");
      const tooltipCount = tooltipCountElements.length;
      this.ele.nativeElement.setAttribute("data-tooltipcount", (tooltipCount + 1).toString());

      if (this.isShownHint) {
        this.isShownHint = false;
        const existingTooltip = document.getElementById("tooltip-" + this.qid);
        if (existingTooltip) {
          existingTooltip.remove();
        }
        return;
      }

      if (event.type == "click" || event.type == "touchstart") {
        this.isShownHint = true;
      }
      
      const existingTooltip = document.getElementById("tooltip-" + this.qid);
      if (existingTooltip) {
        existingTooltip.remove();
      }
      
      const tooltip = document.createElement("div");
      tooltip.classList.add("tooltip_container");
      tooltip.classList.add("datatooltip");
      tooltip.id = "tooltip-" + this.qid;
      tooltip.classList.add("active");
      tooltip.setAttribute("data-tooltip", (tooltipCount + 1).toString());
      tooltip.innerHTML = this.dataContext;
      this.ele.nativeElement.setAttribute("aria-label", `Tip: ${this.dataContext}`);
      this.ele.nativeElement.setAttribute("role", "tooltip");
      document.body.appendChild(tooltip);
      
      const rect = this.ele.nativeElement.getBoundingClientRect();
      const top = rect.top + window.scrollY;
      const left = rect.left + window.scrollX;
      
      if (this.service.commonSetting.isMobileDevice) {
        tooltip.classList.add("mobile-hint");
        
        const arrowSpan = document.createElement('span');
        arrowSpan.className = 'qhint-tooltip-arrow';
        tooltip.appendChild(arrowSpan);
        
        tooltip.style.top = (top + 25) + "px";
        tooltip.style.left = (left - 30) + "px";
        
        const mobileWrapper = document.querySelector('.mobile-wrapper');
        
        if (mobileWrapper) {
          const mobileWrapperRect = mobileWrapper.getBoundingClientRect();
          const tooltipRect = tooltip.getBoundingClientRect();
          
          const diff = (mobileWrapperRect.width - (tooltipRect.width + tooltipRect.left + 20));
          
          if (diff < 0) {
            let checkLeft = left - 30 + diff;
            if (checkLeft < 0) {
              tooltip.style.left = "0px";
            } else {
              tooltip.style.left = (left - 30 + diff) + "px";
            }
          }
          
          if (tooltipRect.height > 50) {
            tooltip.style.left = "10px";
            
            const updatedTooltipRect = tooltip.getBoundingClientRect();
            if ((rect.left - (updatedTooltipRect.left + updatedTooltipRect.width) > 0)) {
              const posDiff = rect.left - (updatedTooltipRect.left + updatedTooltipRect.width);
              tooltip.style.left = (updatedTooltipRect.left + posDiff + 30) + "px";
            }
          }
          
          const finalTooltipRect = tooltip.getBoundingClientRect();
          const arrowLeft = rect.left - finalTooltipRect.left;
          arrowSpan.style.left = arrowLeft + "px";
        }
      } else {
        tooltip.style.top = (top + 25) + "px";
        tooltip.style.left = (left - 30) + "px";
      }
      
      const toolTipText = tooltip.textContent || '';
      tooltip.innerHTML = '';
      
      const wrapperDiv = document.createElement('div');
      wrapperDiv.className = 'tooltip-text-wrapper';
      wrapperDiv.textContent = toolTipText;
      tooltip.appendChild(wrapperDiv);
    }
    } catch (error) {
      console.warn('Error in showTooltip:', error);
    }
  }
}
